import { lazy, FC, Suspense, useState, useEffect } from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import { MasterLayout } from "../../_jutemplate/layout/MasterLayout";
import TopBarProgress from "react-topbar-progress-indicator";
import { getCSSVariableValue } from "../../_jutemplate/assets/ts/_utils";

// redux
import { shallowEqual, useSelector } from "react-redux";
import { RootState } from "../../setup";

// page
import { DashBoard } from "../pages/NewDashboard";

const CropRootPage = lazy(() => import("../modules/crop/pages/CropRootPage"));
const DiseaseRootPage = lazy(
  () => import("../modules/disease/pages/DiseaseRootPage")
);
const SeasonRootPage = lazy(
  () => import("../modules/season/pages/SeasonRootPage")
);

const DesignationRootPage = lazy(
  () => import("../modules/designation/pages/DesignationRootPage")
);

const RunningExperimentRootPage = lazy(
  () => import("../modules/running-experiment/pages/RunningExperimentRootPage")
);

const ExperimentRequestRootPage = lazy(
  () => import("../modules/experiment-request/pages/ExperimentRequestRootPage")
);

const PendingUserRootPage = lazy(
  () => import("../modules/pending-user/pages/PendingUserRootPage")
);

const AdminRootPage = lazy(
  () => import("../modules/admin/pages/AdminRootPage")
);

const EmployeeRootPage = lazy(
  () => import("../modules/employee/pages/EmployeeRootPage")
);

const DepartmentRootPage = lazy(
  () => import("../modules/department/pages/DepartmentRootPage")
);

const UpdateAdminProfilePage = lazy(
  () => import("../modules/admin-profile/pages/UpdateAdminProfilePage")
);

const ChangePasswordPage = lazy(
  () => import("../modules/admin-profile/pages/ChangePasswordPage")
);


const PrivateRoutes = () => {
  // const [islogin, setIslogin] = useState<any>({});
  // const isAuthorized: any = useSelector<RootState>(
  //   ({ auth }) => auth.user,
  //   shallowEqual
  // );
  // console.log(isAuthorized);

  return (
    <Routes>
      <Route element={<MasterLayout />}>
        {/* Redirect to Dashboard after success login/registartion */}
        <Route path="auth/*" element={<Navigate to="/dashboard" />} />

        <Route path="dashboard" element={<DashBoard />} />

        <Route
          path="/crop/*"
          element={
            <SuspensedView>
              <CropRootPage />
            </SuspensedView>
          }
        />

        <Route
          path="/disease/*"
          element={
            <SuspensedView>
              <DiseaseRootPage />
            </SuspensedView>
          }
        />

        <Route
          path="/season/*"
          element={
            <SuspensedView>
              <SeasonRootPage />
            </SuspensedView>
          }
        />

        <Route
          path="/designation/*"
          element={
            <SuspensedView>
              <DesignationRootPage />
            </SuspensedView>
          }
        />

        <Route
          path="/running-experiment/*"
          element={
            <SuspensedView>
              <RunningExperimentRootPage />
            </SuspensedView>
          }
        />

        <Route
          path="/experiment-request/*"
          element={
            <SuspensedView>
              <ExperimentRequestRootPage />
            </SuspensedView>
          }
        />

        <Route
          path="/pending-user/*"
          element={
            <SuspensedView>
              <PendingUserRootPage />
            </SuspensedView>
          }
        />
        <Route
          path="/admin/*"
          element={
            <SuspensedView>
              <AdminRootPage/>
            </SuspensedView>
          }
        />

        <Route
          path="/employee/*"
          element={
            <SuspensedView>
              <EmployeeRootPage/>
            </SuspensedView>
          }
        />

        <Route
          path="/department/*"
          element={
            <SuspensedView>
              <DepartmentRootPage />
            </SuspensedView>
          }
        />

        <Route
          path="/profile"
          element={
            <SuspensedView>
              <UpdateAdminProfilePage />
            </SuspensedView>
          }
        />

        <Route
          path="/change-password"
          element={
            <SuspensedView>
              <ChangePasswordPage />
            </SuspensedView>
          }
        />

        {/* Page Not Found */}
        <Route path="*" element={<Navigate to="/error/404" />} />
      </Route>
    </Routes>
  );
};

const SuspensedView: FC<{ children: React.ReactNode }> = ({ children }) => {
  const baseColor = getCSSVariableValue("--bs-primary");
  TopBarProgress.config({
    barColors: {
      "0": baseColor,
    },
    barThickness: 1,
    shadowBlur: 5,
  });
  return <Suspense fallback={<TopBarProgress />}>{children}</Suspense>;
};

export { PrivateRoutes };
